import { c as _c } from "react/compiler-runtime";
import { CheckBoxSwitcher, TimePicker } from '@systemeio/ui';
import { ActivateCampaignStepContentProps } from 'modules/campaigns/campaign-steps/components/activate-campaign-step/activate-campaign-step-content-without-button';
import { ActionType } from 'modules/campaigns/campaign-steps/components/activate-campaign-step/store';
import React, { useEffect, useState } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
interface SendingEmailTimeSelectorProps extends Pick<ActivateCampaignStepContentProps, 'dispatch'> {
  time: ActivateCampaignStepContentProps['state']['chosenSendingEmailTime'];
  error?: string;
}
export function SendingEmailTimeSelector(t0) {
  const $ = _c(23);
  const {
    time,
    dispatch,
    error
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const [opened, setOpened] = useState(false);
  let t1;
  let t2;
  if ($[0] !== time) {
    t1 = () => {
      if (typeof time === "number") {
        setOpened(true);
      }
    };
    t2 = [time];
    $[0] = time;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== t) {
    t3 = t("dashboard.campaign_step.activate.time_of_the_day.label");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== dispatch) {
    t4 = value => {
      setOpened(value);
      if (!value) {
        dispatch({
          type: ActionType.set_chosen_sending_email_time,
          payload: null
        });
      }
    };
    $[5] = dispatch;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== opened || $[8] !== t3 || $[9] !== t4) {
    t5 = <CheckBoxSwitcher label={t3} selected={opened} onChange={t4} />;
    $[7] = opened;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== dispatch || $[12] !== opened || $[13] !== time || $[14] !== user?.dateFormat || $[15] !== user?.timeFormat) {
    t6 = opened && <TimePicker seconds={time} onChangeSeconds={value_0 => dispatch({
      type: ActionType.set_chosen_sending_email_time,
      payload: value_0
    })} userDateFormat={user?.dateFormat} userTimeFormat={user?.timeFormat} />;
    $[11] = dispatch;
    $[12] = opened;
    $[13] = time;
    $[14] = user?.dateFormat;
    $[15] = user?.timeFormat;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== error) {
    t7 = <FieldErrorAndDescription error={error} />;
    $[17] = error;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <div className="flex flex-col gap-1.5">{t5}{t6}{t7}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}